import { BoardSettingsModel } from "models/BoardSettingsModel";
import { PatchBoardModel } from "models/PatchBoardModel";
import { createContext } from "react";
import { UseFormReturn } from "react-hook-form";

export interface EditBoardConfigurationFieldValues {
  signatureFirstName: string;
  signatureLastName: string;
  defaultDuration?: number;
  defaultTime: string;
  defaultLocation: string;
  defaultRemarks: string;
}

export function getEditBoardConfigurationFieldValues(
  board: BoardSettingsModel | undefined
): EditBoardConfigurationFieldValues {
  return {
    signatureFirstName: board?.signatureFirstName ?? "",
    signatureLastName: board?.signatureLastName ?? "",
    defaultDuration: board?.defaultDuration ? Number(board.defaultDuration) : undefined,
    defaultTime: board?.defaultTime ?? "",
    defaultLocation: board?.defaultLocation ?? "",
    defaultRemarks: board?.defaultRemarks ?? "",
  };
}

export interface EditBoardConfigurationContextProps {
  confirmUnsaved: boolean;
  setConfirmUnsaved: (value: boolean) => void;
  isDirty: boolean;
  isValid: boolean;
  isLoading: boolean;
  isSubmittable: boolean;
  isSubmitting: boolean;
  form: UseFormReturn<EditBoardConfigurationFieldValues>;
  getPatch: (values: EditBoardConfigurationFieldValues) => PatchBoardModel;
  handleSave: () => Promise<void>;
  handleClose: (ignoreDirty?: boolean) => void;
  openEditBoardConfiguration: () => void;
}

export const EditBoardConfigurationContext = createContext({} as EditBoardConfigurationContextProps);
